import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { Actions, ofActionSuccessful } from '@ngxs/store';
import { map, take } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { FeaturesModel } from '@bayclubs/employee-management-api';
import { FeaturesFacade } from '../+store/features.facade';
import { LoadFeaturesSuccessAction } from '../+store/features.actions';

@Injectable({ providedIn: 'root' })
export class FeaturesResolverService  {
    constructor(private featuresFacade: FeaturesFacade, private actions$: Actions) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<FeaturesModel> | FeaturesModel {
        const features = this.featuresFacade.getFeaturesSnapshot();
        if (features.loaded) {
            return features.data;
        } else {
            this.featuresFacade.loadFeatures();
            return this.actions$
                .pipe(ofActionSuccessful(LoadFeaturesSuccessAction))
                .pipe(take(1), map(x => x.features))
        }
    }
}
